import Counter from '@sharedComponents/Counter';
import Typography from '@sharedComponents/Typography';
import propTypes from 'prop-types';

import * as style from './style.module.css';

const Tab = ({ label, count, selected = false, onClick }) => {
    return (
        <div
            className={`${style.tab} ${selected ? style.selected : ''}`}
            onClick={onClick}
            onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
            role="tab"
            tabIndex={0}
        >
            <Typography fontSize="l" fontWeight={selected ? 'medium' : 'regular'}>
                {label}
            </Typography>
            {!!count && <Counter count={count} />}
        </div>
    );
};

Tab.propTypes = {
    label: propTypes.string.isRequired,
    count: propTypes.number,
    selected: propTypes.bool,
    onClick: propTypes.func,
};

export default Tab;
